import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.regexp.exec.js";
import _isFunction from "lodash/isFunction";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.concat.js";

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import { useCallback, useEffect, useRef, useState } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
export var ScrollTransform = function ScrollTransform(_ref) {
  var children = _ref.children,
      _ref$disableCalculate = _ref.disableCalculateOnMount,
      disableCalculateOnMount = _ref$disableCalculate === void 0 ? false : _ref$disableCalculate,
      _ref$onChange = _ref.onChange,
      onChange = _ref$onChange === void 0 ? function () {} : _ref$onChange,
      _ref$startScrollPerce = _ref.startScrollPercent,
      startScrollPercent = _ref$startScrollPerce === void 0 ? 0 : _ref$startScrollPerce,
      _ref$endScrollPercent = _ref.endScrollPercent,
      endScrollPercent = _ref$endScrollPercent === void 0 ? 1 : _ref$endScrollPercent,
      _ref$transforms = _ref.transforms,
      transforms = _ref$transforms === void 0 ? [] : _ref$transforms;
  var attachTo = useRef(null);

  var _useState = useState(0),
      _useState2 = _slicedToArray(_useState, 2),
      setPercentScrollState = _useState2[1];

  var _useState3 = useState(0),
      _useState4 = _slicedToArray(_useState3, 2),
      setPercentValueState = _useState4[1];

  var getTransformStyle = useCallback(function (percentValue) {
    if (startScrollPercent >= endScrollPercent) {
      return null;
    }

    var transformStyles = transforms.map(function (item) {
      var value = item.startValue + (item.endValue - item.startValue) * percentValue;
      return "".concat(item.transformFunction, "(").concat(value).concat(item.unit, ")");
    });
    return {
      transform: transformStyles.join(' ')
    };
  }, [endScrollPercent, startScrollPercent, transforms]);
  var transformStyle = useRef(getTransformStyle(0));

  var calculateVerticalPercentage = function calculateVerticalPercentage(bounds) {
    if (!window) {
      return 0;
    }

    if (!window.innerHeight || !bounds.height) {
      return 0;
    }

    var percentScroll = bounds.bottom / (window.innerHeight + bounds.height);
    return 1 - Math.max(0, Math.min(1, percentScroll));
  };

  var calculateOnScroll = useCallback(function () {
    var forceUpdate = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

    if (window && (forceUpdate && typeof window.pageYOffset !== 'undefined' || !forceUpdate && window.pageYOffset)) {
      setPercentScrollState(function (currentPercentScroll) {
        if (!attachTo || !attachTo.current) {
          return currentPercentScroll;
        }

        var bounds = attachTo.current.getBoundingClientRect();
        var percentScroll = calculateVerticalPercentage(bounds);

        if (forceUpdate || percentScroll !== currentPercentScroll) {
          var _percentValue = endScrollPercent === startScrollPercent ? 0 : percentScroll < startScrollPercent ? 0 : percentScroll > endScrollPercent ? 1 : (percentScroll - startScrollPercent) / (endScrollPercent - startScrollPercent);

          onChange(_percentValue, percentScroll);
          setPercentValueState(function (currentPercentValue) {
            transformStyle.current = getTransformStyle(currentPercentValue) || {};
            return _percentValue;
          });
          return percentScroll;
        }

        return currentPercentScroll;
      });
    }
  }, [attachTo, endScrollPercent, startScrollPercent, onChange, transformStyle, getTransformStyle]);

  var forceRecalculate = function forceRecalculate() {
    calculateOnScroll(true);
  };

  useEffect(function () {
    var updateOnScroll = function updateOnScroll() {
      calculateOnScroll();
    };

    window.addEventListener('scroll', updateOnScroll);
    window.addEventListener('resize', updateOnScroll);

    if (!disableCalculateOnMount) {
      updateOnScroll();
    }

    return function () {
      window.removeEventListener('scroll', updateOnScroll);
      window.removeEventListener('resize', updateOnScroll);
    };
  }, [disableCalculateOnMount, calculateOnScroll]);
  return /*#__PURE__*/_jsx("div", {
    ref: attachTo,
    style: transformStyle.current || undefined,
    children: _isFunction(children) ? children(forceRecalculate) : children
  });
};